<h2 mat-dialog-title>Anexo</h2>
<mat-dialog-content class="anexo-dialog">
  <p class="anexo-dialog__nome">{{ data.nome || 'Arquivo' }}</p>

  <div class="anexo-dialog__preview" *ngIf="ehImagem">
    <img [src]="urlSegura" [alt]="data.nome">
  </div>

  <div class="anexo-dialog__preview anexo-dialog__preview--pdf" *ngIf="ehPdf">
    <iframe [src]="urlSegura" title="Pré-visualização do PDF"></iframe>
  </div>

  <div class="anexo-dialog__fallback" *ngIf="!ehImagem && !ehPdf">
    <mat-icon>insert_drive_file</mat-icon>
    <p>Pré-visualização não disponível para este tipo de arquivo.</p>
    <p>Use <strong>Baixar</strong> para abrir o arquivo.</p>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button type="button" (click)="fechar()">Fechar</button>
  <button mat-raised-button color="primary" type="button" (click)="baixar()">
    <mat-icon>download</mat-icon>
    Baixar
  </button>
</mat-dialog-actions>
